// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__1S7Mp","Div":"CustomFadeBox_Div__iq_N5","LargeDiv":"CustomFadeBox_LargeDiv__2US2I"};